export default __webpack_public_path__ + "static/media/home_carousel_5.b0f6638e.png";